import { defineMessages } from 'react-intl';

export const eventMessages = defineMessages({
    type: {
        id: 'type',
        defaultMessage: 'Type',
    },
    message: {
        id: 'message',
        defaultMessage: 'Message',
    },
    eventLog: {
        id: 'event-log',
        defaultMessage: 'Event log',
    },
    eventLogs: {
        id: 'event-logs',
        defaultMessage: 'Event logs',
    },
    lprCameraDetection: {
        id: 'lpr-camera-detection',
        defaultMessage: 'LPR camera detection',
    },
    accessKeyReaderDetection: {
        id: 'access-key-reader-detection',
        defaultMessage: 'Access key reader detection',
    },
    identifierCreated: {
        id: 'identifier-created',
        defaultMessage: 'Identifier created',
    },
    visitorIdentifier: {
        id: 'visitor-identifier',
        defaultMessage: 'Visitor identifier',
    },
    gatewayPassAllowed: {
        id: 'gateway-pass-allowed',
        defaultMessage: 'Gateway pass allowed',
    },
    gatewayPassNotAllowed: {
        id: 'gateway-pass-not-allowed',
        defaultMessage: 'Gateway pass not allowed',
    },
    activeStayCreated: {
        id: 'active-stay-created',
        defaultMessage: 'Active stay created',
    },
    activeStayPeriodCreated: {
        id: 'active-stay-period-created',
        defaultMessage: 'Active stay period created',
    },
    activeStayPeriodCompleted: {
        id: 'active-stay-period-completed',
        defaultMessage: 'Active stay period completed',
    },
    activeStayCompleted: {
        id: 'active-stay-completed',
        defaultMessage: 'Active stay completed',
    },
    gatewayOpened: {
        id: 'gateway-opened',
        defaultMessage: 'Gateway opened',
    },
    gatewayClosed: {
        id: 'gateway-closed',
        defaultMessage: 'Gateway closed',
    },
    licensePlate: {
        id: 'license-plate',
        defaultMessage: 'License plate',
    },
    ticket: {
        id: 'ticket',
        defaultMessage: 'Ticket',
    },
    accessKey: {
        id: 'access-key',
        defaultMessage: 'Access key',
    },
    eventLogCustomerSuccessfullyExitMessage: {
        id: 'event-log-customer-successfully-exit-message',
        defaultMessage: `Client with {identifierType} {identifierValue} successfully exited the parking.`,
    },
    eventLogLPRCameraDetectionExitMessage: {
        id: 'event-log-lpr-camera-detection-message',
        defaultMessage: `LPR camera detected license plate {licensePlate}.`,
    },
    eventLogGatewayPassAllowedMessage: {
        id: 'event-log-gateway-pass-allowed-message',
        defaultMessage: `Gateway pass allowed for {identifierType} {licensePlate}.`,
    },
    eventLogGatewayPassNotAllowedMessage: {
        id: 'event-log-gateway-pass-not-allowed-message',
        defaultMessage: `Gateway pass not allowed for {identifierType} {licensePlate}.`,
    },
    eventLogIdentifierCreatedMessage: {
        id: 'event-log-identifier-created-message',
        defaultMessage: `New identifier was created with {identifierType} {licensePlate}.`,
    },
    eventLogAccessKeyReaderDetectedMessage: {
        id: 'event-log-access-key-reader-detected-message',
        defaultMessage: `An access key reader was detected {accessKey}.`,
    },
    eventLogGatewayOpenedMessage: {
        id: 'event-log-gateway-opened-message',
        defaultMessage: `The gateway {gateway} was opened.`,
    },
    eventLogGatewayClosedMessage: {
        id: 'event-log-gateway-closed-message',
        defaultMessage: `The gateway {gateway} was closed.`,
    },
    eventLogVisitorIdentifierMessage: {
        id: 'event-log-visitor-identifier-message',
        defaultMessage: `Visitor with {visitorIdentifierType} {visitorIdentifier} was identified.`,
    },
    eventLogStayPeriodCompletedMessage: {
        id: 'event-log-stay-period-completed-message',
        defaultMessage: `The active stay period for {activeStayRef} has ended.`,
    },
    eventLogActiveStayCompletedMessage: {
        id: 'event-log-active-stay-completed-message',
        defaultMessage: `The active stay for {pastStayRef} has ended.`,
    },
    eventLogActiveStayCreatedMessage: {
        id: 'event-log-active-stay-created-message',
        defaultMessage: `An active stay was created with {identifierType} {identifierValue}.`,
    },
    eventLogActiveStayPeriodCreatedMessage: {
        id: 'event-log-active-stay-period-created-message',
        defaultMessage: `A new active stay period was created {activeStayRef}.`,
    },
    unknown: {
        id: 'unknown',
        defaultMessage: `Unknown`,
    },
    identifierNotWhitelisted: {
        id: 'identifier-not-whitelisted',
        defaultMessage: `Identifier is not whitelisted.`,
    },
    requiredIdentifiersNotCollected: {
        id: 'required-identifiers-not-collected',
        defaultMessage: `The required by the gateway identifiers are not collected.`,
    },
    requiredIdentifiersNotValid: {
        id: 'required-identifiers-not-valid',
        defaultMessage: `The required identifiers are not valid.`,
    },
    activePeriodWithAccessKey: {
        id: 'active-period-with-access-key',
        defaultMessage: `There is an active period with this access key with pass back = False.`,
    },
    membershipNotFound: {
        id: 'membership-not-found',
        defaultMessage: `Membership was not found.`,
    },
    membershipStartingInFuture: {
        id: 'membership-starting-in-future',
        defaultMessage: `The membership is starting in the future.`,
    },
    membershipExpired: {
        id: 'membership-expired',
        defaultMessage: `The membership is expired.`,
    },
    restrictedGatewayByMembershipType: {
        id: 'restricted-gateway-by-membership-type',
        defaultMessage: `The gateway is restricted by the membership type.`,
    },
    missingMembershipZoneRule: {
        id: 'missing-membership-zone-rule',
        defaultMessage: `Missing membership zone rule.`,
    },
    outsideAllowedTimeFrame: {
        id: 'outside-allowed-time-frame',
        defaultMessage: `Outside allowed time frame.`,
    },
    noFreeSpaces: {
        id: 'no-free-spaces',
        defaultMessage: `No free spaces.`,
    },
    reservedSpace: {
        id: 'reserved-space',
        defaultMessage: `Reserved space.`,
    },
    allowedSpace: {
        id: 'allowed-space',
        defaultMessage: `Allowed space.`,
    },
    extraVisitorAllowed: {
        id: 'extra-visitor-allowed',
        defaultMessage: `Extra visitor allowed`,
    },
    allMembershipSpacesUsed: {
        id: 'all-membership-used-used',
        defaultMessage: `All membership spaces are used.`,
    },
    accessKeyNotExists: {
        id: 'access-key-not-exists',
        defaultMessage: `Access key with pass back = False does not exists.`,
    },
    unusedTicketNotExists: {
        id: 'unused-ticket-not-exists',
        defaultMessage: `Unused ticket does not exists.`,
    },
    validIdentifierNotExists: {
        id: 'valid-identifier-not-exists',
        defaultMessage: `Valid identifier does not exists.`,
    },
    clientNotAllowedInEntryZone: {
        id: 'client-not-allowed-in-entry_zone',
        defaultMessage: `Client category is not allowed in entry zone.`,
    },
    zoneNotWorking: {
        id: 'zone-not-working',
        defaultMessage: `Zone is not working.`,
    },
    zoneClientCapacityReached: {
        id: 'zone-client-capacity-reached',
        defaultMessage: `Zone client capacity limit is reached.`,
    },
    zoneNoFreeSpaces: {
        id: 'zone-no-free-spaces',
        defaultMessage: `The zone has no free spaces left.`,
    },
    gatewayDoesNotAllowUnknownMainIdentifier: {
        id: 'gateway-does-not-allow-unknown-main-identifier',
        defaultMessage: `The gateway does not allow unknown main identifier.`,
    },
    activeStayPaid: {
        id: 'active-stay-paid',
        defaultMessage: 'Active stay paid',
    },
});
